// @docs https://[domain]/api/v1/docs
export default {
  List: "/work-levels",
  Detail: "/work-levels",
  Update: "/work-levels",
  Create: "/work-levels",
  ListShort: "/work-levels/short",
};
